export default "__VITE_ASSET__DoUKaCSj__";